export default __webpack_public_path__ + "static/media/user.95058284.jpg";